import React, {useEffect} from 'react';

import { Box, HStack, useRadio, useRadioGroup } from '@chakra-ui/react';

function RadioCard(props) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as='label' m={0} border='0px solid red'>
      <input {...input} />
      <Box
        {...checkbox}
        cursor='pointer'
        borderWidth='0px'
        borderRadius={25}
        // boxShadow="md"
        // bg= 'blue'
        _checked={{
          bg: 'brand.500',
          color: 'gold',
          fontWeight: 600,
          borderColor: 'brand.500',
        }}
        _focus={{
          boxShadow: 'outline',
        }}
        px={5}
        py={0}
      >
        {props.children}
      </Box>
    </Box>
  );
}

// Step 2: Use the `useRadioGroup` hook to control a group of custom radios.
function DateStatusSelector({ options, initialValue, onChange }) {
  // const options = ['all', 'seed', 'tree', 'pancake', 'inactive'];
  // const handleChange = (value) => {
  //   console.log('OH', value)
  //   onChange(value)
  //  }
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'framework',
    defaultValue: initialValue,
    // value: initialValue,
    onChange: onChange,
  });


  const group = getRootProps();

  useEffect(()=>{

  },[initialValue])
  return (
    <HStack {...group} bg='#2a3745' borderRadius={25} boxShadow='md' justifyContent='space-around'>
      {options.map((value) => {
        const radio = getRadioProps({ value });
        return (
          <RadioCard key={value} {...radio}>
            {value}
          </RadioCard>
        );
      })}
    </HStack>
  );
}

export default DateStatusSelector;
